export default () => ({
    isActive: false,
})
